export const FETCH_POS_REQUEST = 'FETCH_POS_REQUEST';
export const FETCH_POS_SUCCESS = 'FETCH_POS_SUCCESS'

export const FETCH_POS_VIEW_REQUEST = 'FETCH_POS_VIEW_REQUEST';
export const FETCH_POS_VIEW_SUCCESS = 'FETCH_POS_VIEW_SUCCESS';